exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-molecules-FormLayout-___FormLayout__container___8gskb {\n  width: 100%;\n}\n\n.src-pc-components-molecules-FormLayout-___FormLayout__title___2FWri {\n  margin-bottom: 8px;\n}\n\n.src-pc-components-molecules-FormLayout-___FormLayout__titleText___jGp6g {\n  color: #3f4b40;\n  font-size: 12px;\n}\n\n.src-pc-components-molecules-FormLayout-___FormLayout__input___iD0zN {\n}\n\n@media screen and (max-width: 480px) {\n  .src-pc-components-molecules-FormLayout-___FormLayout__titleText___jGp6g {\n    font-size: 12px;\n    line-height: 24px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-pc-components-molecules-FormLayout-___FormLayout__container___8gskb",
	"title": "src-pc-components-molecules-FormLayout-___FormLayout__title___2FWri",
	"titleText": "src-pc-components-molecules-FormLayout-___FormLayout__titleText___jGp6g",
	"input": "src-pc-components-molecules-FormLayout-___FormLayout__input___iD0zN"
};